export const CATEGORY_TO_COLOR = {
  "Agricultural/ Agritech": "darkgreen",
  "Artificial Intelligence": "blue",
  "Arts & Culture": "red",
  Automotive: "purple",
  "Cloud Computing": "darkblue",
  "Computer Hardware": "darkblue",
  Construction: "darkgray",
  Consulting: "gray",
  "Design & Print": "red",
  "Digital Marketing": "pink",
  "e-commerce": "orange",
  "Educational/ Edutech": "lightblue",
  "Electronics and Electrical": "darkblue",
  Entertainment: "pink",
  Events: "pink",
  Fashion: "magenta",
  "Financial/Fintech": "maroon",
  "Food & Beverages": "green",
  "Green Technology": "darkgreen",
  "Human Resource": "pink",
  "Internet of Things": "darkblue",
  "IT Products": "black",
  "IT Services": "black",
  "Life Sciences": "darkgreen",
  Logistics: "darkgray",
  "Machine Learning": "blue",
  Manufacturing: "darkblue",
  Media: "pink",
  "Medical & Health/ Medtech": "green",
  "Mobile Application": "black",
  "Not for Profit": "pink",
  Other: "gray",
  Platforms: "blue",
  "Power & Energy": "darkblue",
  "Real Estate": "gold",
  Retail: "orange",
  "Robotic Process Automation (RPA)": "darkblue",
  Robotics: "darkblue",
  "Social Innovation": "lightblue",
  Sports: "pink",
  "Telecommunication and Networking": "darkblue",
  "Travel & Tourism": "darkgreen",
  "UI / UX": "black",
};

export const CATEGORIES = Object.keys(CATEGORY_TO_COLOR);
export const CATEGOTY_TO_CATEGORY_I = CATEGORIES.reduce(function (
  CATEGOTY_TO_CATEGORY_I,
  category,
  i
) {
  CATEGOTY_TO_CATEGORY_I[category] = i;
  return CATEGOTY_TO_CATEGORY_I;
},
{});
